import styled from "styled-components";

export const AnimatedLogoContainer = styled.svg`
  overflow: visible;
`;
